import { DragAndDrop as Root, type DragAndDropProps, DragDropContext } from './DragAndDrop';
import { DragAndDropItem } from './DragAndDropItem';

export const DragAndDrop = Object.assign(Root, { Item: DragAndDropItem, Context: DragDropContext });
export { type DragAndDropProps };
